export const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "OnInitState":
      return onInitState(state, action);

    case "OnPropertyChanged":
      return onPropertyChanged(state, action);

    case "OnDocumentScheduleParamAdd":
      return onDocumentScheduleParamAdd(state, action);

    case "OnDocumentScheduleParamsDelete":
      return onDocumentScheduleParamsDelete(state, action);

    default: {
      return state;
    }
  }
}

function onInitState(state, action) {
  const { documentScheduleParams } = action;

  return {
    ...state,
    documentScheduleParams: documentScheduleParams
  };
}

function onPropertyChanged(state, action) {
  const { scheduleTypeParamId, value } = action.payload;
  return {
    ...state,
    documentScheduleParams: state.documentScheduleParams.map(el =>
      el.scheduleTypeParamId === scheduleTypeParamId
        ? {
            ...el,
            paramValue: value
          }
        : el
    )
  };
}

function onDocumentScheduleParamAdd(state, action) {
  const { value, typeParamDisplayName, typeParamName, paramTypeCode } = action.payload;
  return {
    ...state,
    documentScheduleParams: [
      ...state.documentScheduleParams,
      { scheduleTypeParamId: value, typeParamDisplayName, typeParamName, paramTypeCode }
    ]
  };
}

function onDocumentScheduleParamsDelete(state, action) {
  const { value } = action.payload;
  const newList = [...state.documentScheduleParams];
  newList.forEach((el, idx) => {
    if (el.scheduleTypeParamId === value) newList.splice(idx, 1);
  });
  return {
    ...state,
    documentScheduleParams: newList
  };
}
